$shm_projects_configuration $mol_page
	project_id \
	title \Конфигурация
	body /
		<= Form $mol_form
			form_fields /
				<= Session_directory_field $mol_form_field
					name \Рабочая директория агентских сессий
					Content <= Session_directory $mol_text
						text <= session_directory \
				<= Session_agents_field $mol_form_field
					name \Инструкции агентских сессий
					Content <= Session_agents $mol_text
						text <= session_agents \
				<= Tree $shm_tree
					roots <= node_roots /
					children* <= node_children* /
					expanded*? => node_expanded*?
					expanded_default* <= node_expanded_default* true
					expanded_key* <= node_expanded_key* \
					Item* <= Node*
			submit_title \Сохранить
			message_done \Сохранено
			save? <=> save? null
	Node* $mol_view
		sub <= node_content* /
	Node_title* $mol_view
		sub / <= node_label* \
	Text_field* $mol_form_field
		name <= node_label* \
		Content <= Text* $mol_textarea
			value? <=> node_string*? \
	Number_field* $mol_form_field
		name <= node_label* \
		Content <= Number* $mol_number
			value? <=> node_number*? 0
	Boolean* $mol_check_box
		title <= node_label* \
		checked? <=> node_boolean*? false
	List_field* $mol_form_field
		name <= node_label* \
		Content <= List* $mol_textarea
			hint \По одному значению на строке
			value? <=> node_list*? \
